<template>
  <div class="shortcuts">
    <div
      class="shortcut-item"
      v-for="(shortcut, index) in shortcuts"
      :key="index"
    >
      <div class="keys">
        <span
          v-for="(key, i) in shortcut.keys"
          :key="i"
          class="key"
        > {{ key }}
        </span> 
      </div>
      <div class="description">{{ shortcut.description }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shortcuts: [
        { keys: ["Ctrl", "C"], description: this.$t('workspace.shortcuts.copy') },
        { keys: ["Ctrl", "V"], description: this.$t('workspace.shortcuts.paste') },
        { keys: ["Ctrl", "L"], description: this.$t('workspace.shortcuts.create_connection') },
        { keys: ["Ctrl", "R"], description: this.$t('workspace.shortcuts.rotate_components') },
        { keys: ["Ctrl", "F"], description: this.$t('workspace.shortcuts.mirror_mode') },
        { keys: [this.$t('workspace.shortcuts.right_click'), this.$t('workspace.shortcuts.drag')], description: this.$t('workspace.shortcuts.pan_canvas') },
        { keys: [this.$t('workspace.shortcuts.left_click'), this.$t('workspace.shortcuts.hold')], description: this.$t('workspace.shortcuts.select_elements') },
      ]
    }
  }
}
</script>

<style scoped>
.shortcuts {
  background: #fff;
  border: 1px solid #ccc;
  padding: 1rem;
  border-radius: 6px;
  width: 310px;
  font-size: small;
}

.shortcut-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.keys {
  display: flex;
  gap: 2px;
  margin-right: 8px;
}

.key {
  background: #eee;
  border: 1px solid #ccc;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: monospace;
}

.description {
  flex: 1;
}
</style>
